var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles, Snackbar as MUISnackbar, useMediaQuery, } from '@material-ui/core';
import theme from '@dev-togetherprice/theme';
const useStyles = makeStyles(() => ({
    root: {
        [theme.breakpoints.up('md')]: {
            maxWidth: 600,
        },
    },
    error: {
        backgroundColor: theme.palette.error.dark,
        color: theme.palette.common.white,
    },
    success: {
        backgroundColor: theme.palette.primary.dark,
        color: theme.palette.common.white,
    },
    warning: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.common.white,
    },
    info: {
        backgroundColor: theme.palette.info.dark,
        color: theme.palette.common.white,
    },
}));
const Snackbar = (_a) => {
    var { variant = 'success', time = 5000, message } = _a, props = __rest(_a, ["variant", "time", "message"]);
    const classes = useStyles();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    return (React.createElement(MUISnackbar, Object.assign({ className: classes.root, ContentProps: { className: classes[variant] }, autoHideDuration: time, transitionDuration: 400, anchorOrigin: {
            vertical: 'top',
            horizontal: isDesktop ? 'right' : 'center',
        }, message: message }, props)));
};
export default Snackbar;
